/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 11:18:56
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-03 11:31:40
 * @Description: 活动微信授权
 * 自定义Vue.prototype:
 * $channel   渠道
 * $fopenid   上级传播者openid
 * $userInfo  用户信息
 * $openid    用户openid
 * $appid     用户openid对应的微信公众号appid
 */
import Vue from 'vue/dist/vue.js';
import VueRouter from "vue-router";
Vue.use(VueRouter);
import request from "@/http/common";
import util from "@/utils/common";
import servicesActWxjssdk from '@/services/act-wxjssdk';
import servicesRushiH5jssdk from '@/services/rushi-h5-jssdk';
import apiActWxauth from "@/api/act-wxauth";
import apiActLogicPlatform from "@/api/act-logic-platform";
let isInitWx = false;
let isInitRushiH5 = false;
export default class MyRouter {

  constructor(options) {
    this.options = options
    console.log("@/routers/wxauth-act.js options", this.options);
    this.router = new VueRouter({
      routes: []
    })

    /**
     * 注册一个全局前置守卫
     * 
     * 当一个导航触发时，全局前置守卫按照创建顺序调用。守卫是异步解析执行，此时导航在所有守卫 resolve 完之前一直处于 等待中。
    
    每个守卫方法接收三个参数：
    to: Route: 即将要进入的目标 路由对象
    from: Route: 当前导航正要离开的路由
    next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed (确认的)。
    next(false): 中断当前的导航。如果浏览器的 URL 改变了 (可能是用户手动或者浏览器后退按钮)，那么 URL 地址会重置到 from 路由对应的地址。
    next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。你可以向 next 传递任意位置对象，且允许设置诸如 replace: true、name: 'home' 之类的选项以及任何用在 router-link 的 to prop 或 router.push 中的选项。
    next(error): (2.4.0+) 如果传入 next 的参数是一个 Error 实例，则导航会被终止且该错误会被传递给 router.onError() 注册过的回调。
    确保要调用 next 方法，否则钩子就不会被 resolved。
     */
    this.router.beforeEach((to, from, next) => {
      // 设置页面title
      if (to.meta.title) {
        document.title = to.meta.title;
      }
      // 初始化cookies，是否有fake
      this.initCookies(to);
      // 初始化传播信息
      if (to.query && to.query.channel) {
        Vue.prototype.$channel = to.query.channel;
        util.cookie.set('channel', to.query.channel, { expires: 30 })
      } else {
        Vue.prototype.$channel = util.cookie.get("channel") || Vue.prototype.$channel || 0
      }
      if (to.query && (to.query.fopenid || to.query.refereeopenid)) {
        Vue.prototype.$fopenid = to.query.fopenid ? to.query.fopenid : to.query.refereeopenid;
      } else {
        if (!Vue.prototype.$fopenid) {
          Vue.prototype.$fopenid = '';
        }
      }
      if (to.query && to.query.avoidWeChatBug) {
        Vue.prototype.$avoidWeChatBug = to.query.avoidWeChatBug;
      } else {
        Vue.prototype.$avoidWeChatBug = ''
      }
      if (to.query && to.query.rscuid) {
        Vue.prototype.$rscuid = to.query.rscuid;
      } else {
        if (!Vue.prototype.$rscuid) {
          Vue.prototype.$rscuid = '';
        }
      }
      //投放Id
      if (to.query && to.query.adPushId) {
        Vue.prototype.$adPushId = to.query.adPushId;
      } else {
        if (!Vue.prototype.$adPushId) {
          Vue.prototype.$adPushId = '';
        }
      }
      if (to.query && to.query.salesOpenId||to.query.fromSaleOpenId||(to.query.refereeopenid)  ) {
        Vue.prototype.$salesOpenId = to.query.salesOpenId
      } else {
        if (!Vue.prototype.$salesOpenId) {
          Vue.prototype.$salesOpenId = '';
        }
      }
      if (to.query && to.query.projectId && to.query.projectId != 'undefined') {
        Vue.prototype.$projectId = to.query.projectId;
        util.cookie.set("projectId", to.query.projectId, {
          expires: 60,
        });
      } else {
        if (!Vue.prototype.$projectId) {
          Vue.prototype.$projectId = Vue.prototype.$config.projectId;
        }
      }
      // 判断授权方式
      if (to.meta.requiresAuth && to.meta.requiresAuth === 2) {
        // 不授权
        next();
      } else {
        // 判断授权信息是否还能用
        if (this.checkAuthCanUse()) {
          if (Vue.prototype.$userInfo) {
            next();
          } else {
            this.getUserInfo(Vue.prototype.$openid).then((res) => {
              if (res && res.data && res.data.data) {
                Vue.prototype.$userInfo = res.data.data;
              }
              next();
            })
          }
        } else {
          this.getAuthUrl(to).then((res) => {
            console.log("res==>", res);
            if (res && res.data && res.data.data && res.data.data.hrefUrl) {
              window.location.replace(res.data.data.hrefUrl);
            } else {
              alert("授权链接获取失败！");
            }
          })
        }
      }
    });
    this.router.afterEach(() => {
      if (!isInitRushiH5 && Vue.prototype.$config.openSalesLeads) {
        isInitRushiH5 = true;
        servicesRushiH5jssdk.init({
          openid: Vue.prototype.$openid,
          refereeopenid: Vue.prototype.$fopenid,
          channelid: Vue.prototype.$channel,
          rscuid: Vue.prototype.$rscuid
        })
      }

      if (!isInitWx) {
        isInitWx = true;
        servicesActWxjssdk.init(this.options.servicesActWxjssdk);
      }
      window.scrollTo(0, 0);
      Vue.prototype.$config.openYqAnalytics && Vue.prototype.$biz.handlerYqAnalyticsEvent('openPage')
    })
  }

  initCookies(to) {
    if (to.query.cmd && to.query.cmd === "clean") {
      let cookieList = window.document.cookie.match(/[^ =;]+(?==)/g);
      if (cookieList && cookieList.length > 0) {
        cookieList.forEach(name => {
          util.cookie.remove(name);
        });
      }
      let url = `${window.location.protocol}//${window.location.host}${window.location.pathname}#${to.path}`;
      window.location.replace(url);
    } else if (to.query.fake) {
      if (this.options.fake) {
        if (this.options.fake[to.query.fake]) {
          Object.getOwnPropertyNames(this.options.fake[to.query.fake]).forEach(name => {
            util.cookie.set(name, this.options.fake[to.query.fake][name], {
              expires: 30 //天
            });
          })
        } else {
          alert(`本项目目录router未配置名为${to.query.fake}的fake`)
        }
      } else {
        alert("本项目目录router未配置fake")
      }
    } else {
      let appId = sessionStorage.getItem("actAppId");
      let openId = sessionStorage.getItem("actOpenId");
      if (appId && openId) {
        util.cookie.set('actAppId', appId, { expires: 30 });
        util.cookie.set('actOpenId', openId, { expires: 30 });
      }
    }
  }

  checkAuthCanUse() {
    let actOpenId = util.cookie.get("actOpenId");
    let actAppId = util.cookie.get("actAppId");
    if (actOpenId && actAppId) {
      apiActWxauth.openid = actOpenId;
      Vue.prototype.$openid = actOpenId;
      Vue.prototype.$appid = actAppId;
      return true;
    } else {
      return false;
    }
  }

  getAuthUrl(to) {
    return new Promise((resolve, reject) => {
      // 获取授权链接
      let query = {
        htmlUrl: encodeURIComponent(location.href)
      }
      request.post(
        `${apiActWxauth.protocol}//${apiActWxauth.appid}.${apiActWxauth.domain}${apiActWxauth.action.auth}/${to.meta.requiresAuth}?${request.qs.stringify(query)}`,
        {}
      ).then(function (res) {
        resolve(res);
      }).catch((res) => {
        reject(res);
      })
    })
  }

  getUserInfo(openid) {
    // 获取当前用户信息
    return new Promise((resolve, reject) => {
      request.get(
        `${apiActLogicPlatform.protocol}//${apiActLogicPlatform.protocol == "https:" ? location.host : apiActLogicPlatform.domain}${apiActLogicPlatform.action.getUserInfo}/${openid}`,
        {}
      ).then(function (res) {
        resolve(res);
      }).catch((res) => {
        reject(res);
      })
    })
  }
}
